module.exports = __webpack_public_path__ + "media/images/img_completed-all-31c3256bf688d4315d1b9b5831b6e51f.png";